import {
  COMPANIES_LIST,
  COMPANIES_LIST_SUCCESS,
  COMPANIES_LIST_ERROR,
  COMPANIES_NEW,
  COMPANIES_NEW_SUCCESS,
  COMPANIES_NEW_ERROR,
  COMPANIES_EDIT,
  COMPANIES_DELETE,
  COMPANIES_DELETE_SUCCESS,
  COMPANIES_DELETE_ERROR,
  COMPANIES_EXPORT,
  COMPANIES_IMPORT,
  COMPANIES_IMPORT_SUCCESS,
  COMPANIES_IMPORT_ERROR,
  COMPANIES_EXPORT_ACCOUNTS,
  COMPANIES_IMPORT_ACCOUNTS,
  COMPANIES_IMPORT_ACCOUNTS_SUCCESS,
  COMPANIES_IMPORT_ACCOUNTS_ERROR,
} from "./actionTypes"


export const companiesList = data => ({
  type: COMPANIES_LIST,
  payload: data
});

export const companiesListSuccess = data => ({
  type: COMPANIES_LIST_SUCCESS,
  payload: {data}
});

export const companiesListError = error => ({
  type: COMPANIES_LIST_ERROR,
  payload: error,
});

export const companiesNew = data => ({
  type: COMPANIES_NEW,
  payload: data
});

export const companiesNewSuccess = data => ({
  type: COMPANIES_NEW_SUCCESS,
  payload: {data}
});

export const companiesNewError = error => ({
  type: COMPANIES_NEW_ERROR,
  payload: error,
});

export const companiesEdit = data => ({
  type: COMPANIES_EDIT,
  payload: data
});

export const companiesDelete = data => ({
  type: COMPANIES_DELETE,
  payload: data
});

export const companiesDeleteSuccess = data => ({
  type: COMPANIES_DELETE_SUCCESS,
  payload: {data}
});

export const companiesDeleteError = error => ({
  type: COMPANIES_DELETE_ERROR,
  payload: error,
});

export const companiesExport = data => ({
  type: COMPANIES_EXPORT,
  payload: data
});

export const companiesImport = data => ({
  type: COMPANIES_IMPORT,
  payload: data
});

export const companiesImportSuccess = data => ({
  type: COMPANIES_IMPORT_SUCCESS,
  payload: {data}
});

export const companiesImportError = error => ({
  type: COMPANIES_IMPORT_ERROR,
  payload: error,
});

export const companiesExportAccounts = data => ({
  type: COMPANIES_EXPORT_ACCOUNTS,
  payload: data
});

export const companiesImportAccounts = data => ({
  type: COMPANIES_IMPORT_ACCOUNTS,
  payload: data
});

export const companiesImportAccountsSuccess = data => ({
  type: COMPANIES_IMPORT_ACCOUNTS_SUCCESS,
  payload: {data}
});

export const companiesImportAccountsError = error => ({
  type: COMPANIES_IMPORT_ACCOUNTS_ERROR,
  payload: error,
});
